import { Getter } from "vuex";
import { IState } from "./state";

const messages: Getter<IState, IState> = (state) => state.messages;

export default {
  messages,
};
